import './cardForm.css'
import {Button, IconButton, TextField, Typography} from '@mui/material';
import React, {useEffect, useState} from 'react';
import CloseIcon from '@mui/icons-material/Close';
import {useTranslation} from 'react-i18next';
import {dispatch} from '../../store/store';
import {formSlice} from '../../store/form/formSlice';

export const PageUTR = (props) => {
  const {t, i18n} = useTranslation('translation', {keyPrefix: 'CardForm'})
  const {t: ct} = useTranslation('translation', {keyPrefix: 'common'})

  const {setShowUTR, utr, setUTR} = props
  const [showInput, setShowInput] = useState(false)
  const [showInfo, setShowInfo] = useState(false)

  const timeLimit = 60
  const [time, setTime] = useState(timeLimit)
  useEffect(() => {
    const started = Date.now()
    setTime(timeLimit - (Date.now() - started) / 1e3)
    const interval = setInterval(() => {
      const time = timeLimit - (Date.now() - started) / 1e3
      if (time === 0 || time < 0) {
        setTime(0)
        setShowInput(true)
        clearInterval(interval)
        return
      }
      setTime(time)
    }, 1e3)
    return () => clearInterval(interval);
  }, []);

  const timeMin = String(Math.floor(Math.round(time) / 60)).padStart(2, '0')
  const timeSec = String(Math.round(time) % 60).padStart(2, '0')

  return (
    <div className={'utrPage'}>
      <div className={'utrContent'}>

        <div style={{display: 'flex', justifyContent: 'flex-end', marginBottom: 8}}>
          <IconButton
            style={{margin: `-8px`}}
            onClick={() => setShowUTR(false)}
          >
            <CloseIcon/>
          </IconButton>
        </div>

        <div style={{display: 'flex', justifyContent: 'space-around', margin: '12px'}}>
          <Typography style={{fontSize: 24}}>
            {timeMin}:{timeSec}
          </Typography>
        </div>

        <Typography
          style={{
            color: 'rgba(0, 0, 0, 0.87)',
            fontSize: 14,
            fontWeight: 500,
            textTransform: 'initial',
            textAlign: 'center',
            marginBottom: 16,
          }}
        >
          If the payment is not successful within 60 seconds, please fill in the transaction UTR
        </Typography>

        {showInfo && (
          <div style={{marginBottom: 8}}>
            <Typography
              style={{lineHeight: 1.3, color: '#000', fontSize: 12, fontWeight: 500, textTransform: 'initial'}}
            >
              To find the UTR (Unique Transaction Reference) number for a UPI transaction, you can typically locate it
              within your UPI app's transaction history or payment confirmation. Specifically, navigate to the
              "Transaction History" or "Payment History" section, select the relevant transaction, and the UTR number
              will usually be listed in the transaction details.
            </Typography>

            <Typography
              style={{lineHeight: 1.3, marginTop: 12, color: '#000', fontSize: 12, fontWeight: 500, textTransform: 'initial'}}
            >
              Steps to Find UTR for UPI Transactions:
            </Typography>

            <Typography
              style={{lineHeight: 1.2, marginTop: 12, color: '#000', fontSize: 12, fontWeight: 400, textTransform: 'initial'}}
            >
              <span className={'list'}>
                <span key={`key-1`} data-number={`1.`}>
                  Open your UPI app: Access your UPI-enabled application (e.g., Google Pay, Paytm, BHIM).
                </span>
                <span key={`key-2`} data-number={`2.`}>
                  Navigate to Transaction History: Go to the "Transaction History" or "Payment History" section within the app.
                </span>
                <span key={`key-3`} data-number={`3.`}>
                  Select the transaction: Find the specific UPI transaction you're looking for.
                </span>
                <span key={`key-4`} data-number={`4.`}>
                  Locate UTR number: The UTR number (also known as the UPI reference ID) will be displayed in the transaction details.
                </span>
                <span key={`key-5`} data-number={`5.`}>
                  Check for SMS/Email confirmations: If you have registered for SMS or email alerts, you may receive a confirmation message with the UTR number.
                </span>
                <span key={`key-6`} data-number={`6.`}>
                  Check bank statement: You can also find the UTR number in your bank statement, either physical or online.
                </span>
              </span>
            </Typography>

            <Typography
              style={{lineHeight: 1.3, marginTop: 12, color: '#000', fontSize: 12, fontWeight: 500, textTransform: 'initial'}}
            >
              UTR Number Format: The UTR number for UPI transactions is typically a 12-digit numeric code.
            </Typography>

            <Typography
              style={{lineHeight: 1.3, marginTop: 12, color: '#000', fontSize: 12, fontWeight: 500, textTransform: 'initial'}}
            >
              Additional Notes:
            </Typography>

            <Typography
              style={{lineHeight: 1.2, marginTop: 12, color: '#000', fontSize: 12, fontWeight: 400, textTransform: 'initial'}}
            >
              <span className={'list'}>
                <span key={`key-1`} data-number={`•`}>
                  If you cannot find the UTR number within the app or bank statements, you can contact your bank's customer support for assistance.
                </span>

                <span key={`key-2`} data-number={`•`}>
                  The UTR number is crucial for tracking and identifying your specific UPI transaction.
                </span>
              </span>
            </Typography>
          </div>
        )}

        {!showInfo && (
          <Button
            onClick={() => {
              setShowInfo(true)
            }}
            fullWidth
            size="large"
            style={{height: '40px'}}
          >
            Now to find UTR? Click here
          </Button>
        )}

        <div style={{marginTop: 16}}>
          {showInput ? (
            <TextField
              value={utr}
              onChange={e => {
                const valueTrim = e.target.value.trim().replaceAll(' ', '')
                if (valueTrim.length <= 12) {
                  setUTR(e.target.value)
                }
              }}
              fullWidth
              size="small"
              label={'Input 12-digit UTR here'}
              id="utrCode"
            />
          ) : (
            <Button
              onClick={() => {
                setShowInput(true)
                requestAnimationFrame(() => {
                  const el = document.querySelector('#utrCode')
                  el.focus()
                })
              }}
              fullWidth
              variant="contained"
              size="large"
              style={{height: '40px'}}
            >
              Input 12-digit UTR here
            </Button>
          )}

          <Button
            sx={{mb: 2, mt: 2}}
            fullWidth
            variant="contained"
            size="large"
            disabled={utr.trim().replaceAll(' ', '').length !== 12}
            onClick={() => dispatch(formSlice.actions.update({status: 'paid', utr}))}
          >
            Сonfirm
          </Button>

        </div>


      </div>
    </div>
  )
}
